export default "__VITE_ASSET__pzW2cCQF__"